'use client';
import { useState, useEffect } from 'react';
import { setToString } from '../../core/utilities/set.utils.js';
import { iterToSet } from '../../core/utilities/transform.utils.js';

function getBrowserClasses(e = new Set()) {
    let { userAgent: r } = navigator;
    return -1 !== r.indexOf('Safari/') && -1 === r.indexOf('Chrome/') && -1 === r.indexOf('Chromium/') && e.add('swan-safari'), -1 !== r.indexOf('Firefox/') && -1 === r.indexOf('Seamonkey/') && e.add('swan-firefox'), -1 !== r.indexOf('Edg/') && e.add('swan-edge'), e;
}
function useBrowserClasses(t, i) {
    let [n, a] = useState(()=>setToString(iterToSet(i)));
    return useEffect(()=>{
        a(setToString(getBrowserClasses(iterToSet(i))));
    }, [
        i
    ]), useEffect(()=>{
        if (t && n) try {
            let e = document.querySelector('head');
            return null == e || e.classList.add(n), ()=>null == e ? void 0 : e.classList.remove(n);
        } catch (e) {
            console.info('Could not sync browser class name.');
        }
    }, [
        n,
        t
    ]), n;
}

export { useBrowserClasses };
